<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" >
          <router-link v-if="!serverError" :to="{ name: `${zonesRoutePrefix}.edit`,params:{id,city_id,zone_id} }"  class="btn btn-primary btn-sm" v-can:edit="zonesPermissionPrefix">
            <i class="fa fa-edit"></i>
          </router-link>
        </card-header>
        <!-- Card body -->
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error') }} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <div class="row" v-if="!serverError">
              <input-text v-model="en_name" :options="{ id: 'en_name', label: 'en_name', disabled: true }"/>
              <input-text v-model="ar_name" :options="{ id: 'ar_name', label: 'ar_name', disabled: true }"/>
            </div>
            <div class="row" v-if="!serverError">
              <div class="col-12">
                <maps-general v-model="points" :points="oldPoints" :mode="map_mode"/>
              </div>
            </div>
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <router-link :to="{ name: `${zonesRoutePrefix}.index`,params: {id,city_id}}"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { ZONES_SHOW as CRUD_ACTION_SHOW } from 'actions/zones';
  const CRUD_CODE="countries";
  const CITIES_CODE="cities";
  const ZONES_CODE="zones";
  export default {
    name: "CountryCityZoneShow",
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        citiesRoutePrefix: `${CRUD_CODE}.${CITIES_CODE}`,
        citiesTransPrefix: `${CITIES_CODE}`,
        zonesRoutePrefix: `${CRUD_CODE}.${CITIES_CODE}.${ZONES_CODE}`,
        zonesTransPrefix: `${ZONES_CODE}`,
        zonesPermissionPrefix: `locals`,
        id:this.$router.currentRoute.params.id,
        city_id:this.$router.currentRoute.params.city_id,
        zone_id:this.$router.currentRoute.params.zone_id,
        en_name: '',
        ar_name: '',
        points:[],
        oldPoints:[],
        map_mode:'show',
        serverError: '',
        responseStatus:'',
      }
    },
    mounted() {
      this.getItem();
    },
    methods: {
      getItem(){
        this.$store.dispatch(CRUD_ACTION_SHOW,{
          id: this.zone_id,
        }).then(response=>{
          this.en_name=response.data.name;
          this.ar_name=response.data.nameAr;
          this.oldPoints=this.points=response.data.geom?response.data.geom.coordinates[0][0]:[];
        }).catch(error => {
          this.loading = false
          this.serverError='';

          if(error.response){
            this.responseStatus=error.response.status;
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        });
      },
    }
  };
</script>
